import React from 'react'
import MaterialSymbol from '../material-symbol'

const CalendarToday = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="calendar_today" {...props} />
))

CalendarToday.displayName = 'CalendarToday'

export default CalendarToday
